function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Component_146_1",
  "data-name": "Component 146 \\u2013 1",
  transform: "translate(0.5 0.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_533",
  "data-name": "Path 533",
  d: "M8269.506-10623.521h59.667v4.436h-59.667Z",
  transform: "translate(-8269.506 10623.521)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_519",
  "data-name": "Path 519",
  d: "M8269.506-10623.521h59.667v4.436h-59.667Z",
  transform: "translate(-8269.506 10642.672)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_520",
  "data-name": "Path 520",
  d: "M8325.92-10604.907v-10.344h-14.262v10.344h4.994l-.015-10.344h4.507v10.344Z",
  transform: "translate(-8270.181 10624.06)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_521",
  "data-name": "Path 521",
  d: "M8275.161-10604.937v-7.405H8303.5v7.405Z",
  transform: "translate(-8270.469 10624.089)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_98",
  "data-name": "Line 98",
  y2: 6.525,
  transform: "translate(10.074 12.116)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_99",
  "data-name": "Line 99",
  y2: 6.525,
  transform: "translate(16.122 12.116)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_100",
  "data-name": "Line 100",
  y2: 6.525,
  transform: "translate(21.161 12.116)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_101",
  "data-name": "Line 101",
  y2: 6.525,
  transform: "translate(27.209 12.116)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_522",
  "data-name": "Path 522",
  d: "M8269.506-10623.521h59.667v4.436h-59.667Z",
  transform: "translate(-8269.506 10659.807)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_528",
  "data-name": "Path 528",
  d: "M8320.686-10587.443v-5.285l1.254-1.072v-3.64h4.178v3.64l1.131,1.072v5.285Z",
  transform: "translate(-8268.279 10623.729)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_527",
  "data-name": "Path 527",
  d: "M8320.686-10587.443v-5.285l1.254-1.072v-3.64h4.178v3.64l1.131,1.072v5.285Z",
  transform: "translate(-8278.358 10623.729)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_526",
  "data-name": "Path 526",
  d: "M8320.686-10587.443v-5.285l1.254-1.072v-3.64h4.178v3.64l1.131,1.072v5.285Z",
  transform: "translate(-8287.43 10623.729)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_529",
  "data-name": "Path 529",
  d: "M8277.609-10588.051s0-3.571,0-4.819a2.948,2.948,0,0,1,4.25,0c.082,2.1,0,4.819,0,4.819Z",
  transform: "translate(-8273.474 10624.335)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_102",
  "data-name": "Line 102",
  y2: 4.032,
  transform: "translate(6.278 26.288)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_529-2",
  "data-name": "Path 529",
  d: "M8277.609-10588.051s0-3.571,0-4.819a2.948,2.948,0,0,1,4.25,0c.082,2.1,0,4.819,0,4.819Z",
  transform: "translate(-8269.187 10624.335)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_102-2",
  "data-name": "Line 102",
  y2: 4.032,
  transform: "translate(10.565 26.288)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_529-3",
  "data-name": "Path 529",
  d: "M8277.609-10588.051s0-3.571,0-4.819a2.948,2.948,0,0,1,4.25,0c.082,2.1,0,4.819,0,4.819Z",
  transform: "translate(-8264.899 10624.335)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_102-3",
  "data-name": "Line 102",
  y2: 4.032,
  transform: "translate(14.853 26.288)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_529-4",
  "data-name": "Path 529",
  d: "M8277.609-10588.051s0-3.571,0-4.819a2.948,2.948,0,0,1,4.25,0c.082,2.1,0,4.819,0,4.819Z",
  transform: "translate(-8260.611 10624.335)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_102-4",
  "data-name": "Line 102",
  y2: 4.032,
  transform: "translate(19.14 26.288)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_531",
  "data-name": "Path 531",
  d: "M8269.506-10623.521h59.667v4.436h-59.667Z",
  transform: "translate(-8269.506 10677.969)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_530",
  "data-name": "Path 530",
  d: "M8301.251-10571.033s0-4.708.018-6.549a2.006,2.006,0,0,1,3.7,0c.13,1.991,0,6.549,0,6.549Z",
  transform: "translate(-8265.66 10625.384)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_103",
  "data-name": "Line 103",
  y2: 3.024,
  transform: "translate(37.478 43.264)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_530-2",
  "data-name": "Path 530",
  d: "M8301.251-10571.033s0-4.708.018-6.549a2.006,2.006,0,0,1,3.7,0c.13,1.991,0,6.549,0,6.549Z",
  transform: "translate(-8258.842 10625.384)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_103-2",
  "data-name": "Line 103",
  y2: 3.024,
  transform: "translate(44.297 43.264)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_530-3",
  "data-name": "Path 530",
  d: "M8301.251-10571.033s0-4.708.018-6.549a2.006,2.006,0,0,1,3.7,0c.13,1.991,0,6.549,0,6.549Z",
  transform: "translate(-8252.874 10625.384)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_103-3",
  "data-name": "Line 103",
  y2: 3.024,
  transform: "translate(50.263 43.264)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_530-4",
  "data-name": "Path 530",
  d: "M8301.251-10571.033s0-4.708.018-6.549a2.006,2.006,0,0,1,3.7,0c.13,1.991,0,6.549,0,6.549Z",
  transform: "translate(-8246.057 10625.384)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_103-4",
  "data-name": "Line 103",
  y2: 3.024,
  transform: "translate(57.082 43.264)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_532",
  "data-name": "Path 532",
  d: "M8271.291-10569.711v-7.088h26.557v7.088Z",
  transform: "translate(-8269.491 10623.792)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_104",
  "data-name": "Line 104",
  y2: 7.055,
  transform: "translate(8.058 47.295)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_105",
  "data-name": "Line 105",
  y2: 7.055,
  transform: "translate(15.113 47.295)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_106",
  "data-name": "Line 106",
  y2: 7.055,
  transform: "translate(22.169 47.295)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_107",
  "data-name": "Line 107",
  x2: 26.206,
  transform: "translate(1.973 50.822)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeWidth: 1
}));

function SvgSelfstocker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.667,
    height: 59.884,
    viewBox: "0 0 60.667 59.884",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfstocker);
export default __webpack_public_path__ + "static/media/selfstocker.6f88e472a4bbef07bf618ecba89f4546.svg";
export { ForwardRef as ReactComponent };